module.exports = __webpack_public_path__ + "static/img/qiepian0.503b898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qiepian0.png
// module id = Vvar
// module chunks = 2